import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as senderApi from '../Api/senderApi';

const SENDER_KEY = 'senders';

export const useSenders = (companyId) =>
	useQuery({
		queryKey: [SENDER_KEY, companyId],
		queryFn: () =>
			senderApi
				.getSenders(companyId)
				.then((res) =>
					Array.isArray(res.data) ? res.data : res.data.senders || [],
				),
		enabled: !!companyId,
	});

export const useSender = (id, companyId) =>
	useQuery({
		queryKey: [SENDER_KEY, id],
		queryFn: () => senderApi.getSenderById(id, companyId),
		enabled: !!id && !!companyId,
	});

export const useCreateSender = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ data, companyId }) =>
			senderApi.createSender(data, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SENDER_KEY] });
		},
	});
};

export const useUpdateSender = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, data, companyId }) =>
			senderApi.updateSender(id, data, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SENDER_KEY] });
		},
	});
};

export const useDeleteSender = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, companyId }) => senderApi.deleteSender(id, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [SENDER_KEY] });
		},
	});
};
